<template>
  <ul class="statuses-line">
    <li
      v-for="status in statusesLine"
      :key="status.id"
    >
      <div class="statuses-count">{{status.responses_count}}</div>
      <p> {{ status.label }} </p>
    </li>

    <li
      v-if="statusesDummies.length"
      v-for="status in statusesDummies"
      :key="`dummy_${status.id}`"
    >
      <p> </p>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'settings-statuses-row',

  props: {
    statusesLine: {
      type: Array,
      required: true
    },

    statusesDummies: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/colors.scss';
  @import '@/styles/variables.scss';

  ul.statuses-line {
    display: flex;
    flex-direction: row;
    list-style: none;
    width: 100%;
    justify-content: space-between;
    align-items: stretch;
    padding: 0;
    margin-bottom: 24px;

    li {
      text-align: center;
      background: #fff;
      border: solid 1px #D1D8E0;
      flex: 1;
      width: 132px;
      min-width: 132px;
      min-height: 92px;
      border-radius: 2px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      flex-direction: column;
      padding: 12px 10px 4px;

      &:before {
        border-radius: 2px;
        content: "";
        position: absolute;
        z-index: -1;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        border: 2px solid transparent;
      }

      p {
        margin: 0;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 24px;
        color: #233346;
      }

      &.settings { border: none; }

      &.selected h2{
        color: $green-active;
      }
    }

    li + li {
      margin-left: 24px;
    }

    .settings {
      margin-bottom: 0;
    }
  }

  .statuses-count {
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    color: #233346;
  }
</style>
